import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { style: {"width":"80%"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 请上传jpg/png的统一尺寸图片，图片大小不能大于10M ", -1)
const _hoisted_4 = ["src"]

import { reactive, onMounted, ref } from 'vue'
  import api from '@/api/index'
  import { ElMessage, ElLoading, UploadProps, UploadUserFile } from 'element-plus'
  import {useRouter, useRoute} from 'vue-router'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Add',
  setup(__props) {

  const router = useRouter()
  const route = useRoute()
  const dialogDetailImageUrl = ref('')
  const dialogDetailVisible = ref(false)
  const baseData:any = reactive({
    loading: false,
  })
  const ueConfig = reactive({
      UEDITOR_HOME_URL: '/manager/static/UEditor/',
      UEDITOR_CORS_URL: '/manager/static/UEditor/',
      initialFrameWidth: '100%',
      initialFrameHeight: 400,
      autoHeightEnabled: false,
      autoFloatEnabled: false,
      enableAutoSave: false,
      serverUrl: '/api/ueditor/config',
      toolbars: [
          ['fullscreen', 'source', '|', 'undo', 'redo', '|']
      ]
  })
  const form = reactive({
    id: '',
    title:'',
    detail: [],
    status: '1',
  })
  const uploadDetailImg = (params:any) => {
    const file = params.file,formData = new FormData();
    if (file.size / 1024 / 1024 > 6) {
        ElMessage.error('banner轮播图超过10MB!')
        return false
    }
    formData.append("file", file)
    api.commonApi.uploadImg(formData).then((res:any)=>{
        if(res.code == 200){
        let data:any = {name:file.name,url:res.data.img}
        form.detail.pop()
        form.detail.push(data);
        }
    })
  }
  const onSubmit = () => {
    const loading = ElLoading.service({lock: true})
    var data:any = {
      detail: form.detail ? JSON.stringify(form.detail) : "",
      title: form.title,
      status: form.status
    }
    api.qaApi.add(data).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        router.push("/qa");
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const handleDetailPictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
    dialogDetailImageUrl.value = uploadFile.url!
    dialogDetailVisible.value = true
  }
  const handleDetailRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
    console.log(uploadFile, uploadFiles)
  }
  const goBack = () => {
    router.go(-1);
  }
  onMounted(() => {
    console.log(route.query)
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_breadcrumb, {
          class: "breadcrumb",
          separator: "/"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/qa' } }, {
              default: _withCtx(() => [
                _createTextVNode("问题答疑")
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode("创建问题答疑")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.title) = $event)),
                  maxlength: "150",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "详情图" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  "file-list": form.detail,
                  "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((form.detail) = $event)),
                  action: "",
                  "http-request": uploadDetailImg,
                  "list-type": "picture-card",
                  "on-preview": handleDetailPictureCardPreview,
                  "on-remove": handleDetailRemove
                }, {
                  tip: _withCtx(() => [
                    _hoisted_3
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list"]),
                _createVNode(_component_el_dialog, {
                  modelValue: dialogDetailVisible.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogDetailVisible).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      "w-full": "",
                      src: dialogDetailImageUrl.value,
                      alt: "Preview Image"
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.status,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("正常")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "0" }, {
                      default: _withCtx(() => [
                        _createTextVNode("下架")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: goBack }, {
                  default: _withCtx(() => [
                    _createTextVNode("返回")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})